export function AddCircle({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 23 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.25 20.1663C16.2917 20.1663 20.4167 16.0413 20.4167 10.9997C20.4167 5.95801 16.2917 1.83301 11.25 1.83301C6.20837 1.83301 2.08337 5.95801 2.08337 10.9997C2.08337 16.0413 6.20837 20.1663 11.25 20.1663Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.58337 11H14.9167"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 14.6663V7.33301"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
